import { render, staticRenderFns } from "./DetalleGuiaHijas.vue?vue&type=template&id=0627beac&"
import script from "./DetalleGuiaHijas.vue?vue&type=script&lang=js&"
export * from "./DetalleGuiaHijas.vue?vue&type=script&lang=js&"
import style0 from "./DetalleGuiaHijas.vue?vue&type=style&index=0&id=0627beac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports